import { render, staticRenderFns } from "./ToggleTicketAdulityButton.vue?vue&type=template&id=3552f6d1&"
import script from "./ToggleTicketAdulityButton.vue?vue&type=script&lang=js&"
export * from "./ToggleTicketAdulityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports